import React from 'react'

const Grid = React.forwardRef(
  (
    {
      children,
      container = false,
      item = false,
      xs,
      sm,
      md,
      lg,
      xl,
      spacing = 0,
      direction = 'row',
      justifyContent = 'flex-start',
      alignItems = 'stretch',
      className = '',
      sx = {},
      ...props
    },
    ref
  ) => {
    const getGridStyles = () => {
      const styles = {}

      if (container) {
        styles.display = 'flex'
        styles.flexDirection = direction
        styles.justifyContent = justifyContent
        styles.alignItems = alignItems

        if (spacing > 0) {
          styles.gap = `${spacing * 8}px`
        }
      }

      if (item) {
        if (xs !== undefined) {
          styles.flex = `0 0 ${(xs / 12) * 100}%`
        }
        if (sm !== undefined) {
          styles.flex = `0 0 ${(sm / 12) * 100}%`
        }
        if (md !== undefined) {
          styles.flex = `0 0 ${(md / 12) * 100}%`
        }
        if (lg !== undefined) {
          styles.flex = `0 0 ${(lg / 12) * 100}%`
        }
        if (xl !== undefined) {
          styles.flex = `0 0 ${(xl / 12) * 100}%`
        }
      }

      return styles
    }

    const gridStyles = getGridStyles()

    return (
      <div
        ref={ref}
        className={className}
        style={{ ...gridStyles, ...sx }}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Grid.displayName = 'Grid'

export default Grid
